import React, { useState } from 'react';

import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Autocomplete from '@material-ui/lab/Autocomplete';

const TagsTextField = ({ options, tags, selectedTags, onChange, onAdd, disabled }) => {
  const availableOptions = tags || options || [];
  const [value, setValue] = useState('');
  const [inputValue, setInputValue] = React.useState('');

  return (
    <Autocomplete
      freeSolo
      style={{}}
      value={value}
      onChange={(evt, newValue) => {
        if (newValue) {
          const currentTags = selectedTags || [];
          const tagExists = currentTags.some((tag) => tag.toLowerCase().trim() === newValue.toLowerCase().trim());

          if (!tagExists) {
            if (onAdd) {
              onAdd(newValue);
            } else if (onChange) {
              const updatedTags = [...currentTags, newValue];
              onChange(updatedTags);
            }
          }

          setValue('');
          setInputValue('');
        }
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      id="free-solo-2-demo"
      options={availableOptions}
      disabled={disabled}
      ListboxProps={{
        style: {
          border: '2px solid #E7E7E7',
          borderRadius: '5px',
          boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="New Tag"
          margin="normal"
          style={{ margin: 0 }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <InputAdornment>
                <IconButton
                  onClick={() => {
                    if (inputValue) {
                      const currentTags = selectedTags || [];
                      const tagExists = currentTags.some((tag) => tag.toLowerCase().trim() === inputValue.toLowerCase().trim());

                      if (!tagExists) {
                        if (onAdd) {
                          onAdd(inputValue);
                        } else if (onChange) {
                          const updatedTags = [...currentTags, inputValue];
                          onChange(updatedTags);
                        }
                      }

                      setValue('');
                      setInputValue('');
                    }
                  }}>
                  <AddIcon color="primary" />
                </IconButton>
              </InputAdornment>
            ),
            type: 'search',
          }}
        />
      )}
    />
  );
};

export default TagsTextField;
